import { useEffect, useState } from "react";

// ---------------------------------------------------------------------------
// Scroll-reaktives Chrome (Kopfzeile, Tab-Leiste): beim Runterscrollen weichen,
// beim Hochscrollen zurück. Ein Verfahren für alle Stellen — vorher stand es
// zweimal fast gleich (Navbar.jsx und Search.jsx), jede Kopie mit eigenen
// Kleinigkeiten.
//
// rAF-gedrosselt: Der Scroll-Handler zählt nur und plant EINE Auswertung je
// Bild. Sonst rendert React bei jedem Pixel neu, und genau das ließ das Ein-
// und Ausblenden früher ruckeln.
//
// Parameter (Pixel):
//   abY          erst ab dieser Scrolltiefe darf etwas weichen
//   runter       so weit kumuliert runter, bis es weicht
//   hoch         so weit kumuliert hoch, bis es zurückkommt
//   stillstandMs > 0: nach so langer Scrollpause kommt es ebenfalls zurück
//                (App: die Tab-Leiste kehrt zurück, wenn der Wisch ausläuft —
//                mobile/context/TabBarChrome.tsx)
//   aktiv        false = nie weichen (z. B. nur am Handy mitmachen)
// ---------------------------------------------------------------------------
export default function useScrollChrome({ abY = 80, runter = 40, hoch = 320, stillstandMs = 0, aktiv = true } = {}) {
  const [weg, setWeg] = useState(false);

  useEffect(() => {
    if (!aktiv) { setWeg(false); return undefined; }
    let prev = window.scrollY, summeRunter = 0, summeHoch = 0, geplant = false, timer = null;
    const auswerten = () => {
      const y = window.scrollY, d = y - prev; prev = y;
      if (y <= 8) { summeRunter = 0; summeHoch = 0; setWeg(false); }
      else if (d > 0) { summeRunter += d; summeHoch = 0; if (summeRunter > runter && y > abY) setWeg(true); }
      else if (d < 0) { summeHoch -= d; summeRunter = 0; if (summeHoch > hoch) setWeg(false); }
      geplant = false;
    };
    const onScroll = () => {
      if (stillstandMs > 0) {
        clearTimeout(timer);
        timer = setTimeout(() => { summeRunter = 0; setWeg(false); }, stillstandMs);
      }
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(auswerten);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); clearTimeout(timer); };
  }, [abY, runter, hoch, stillstandMs, aktiv]);

  return weg;
}
